<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <!-- 视频开始 -->
  <div class="hbody is-loading">
    <div id="video-container">
      <div class="video-overlay"></div>
      <div class="video-content">
        <div class="landing">
          <!-- Page Wrapper -->
          <div id="page-wrapper">
            <!-- Banner -->
            <section id="banner">
              <div class="inner">
                <h2>F  E  S  A</h2>
                <p>The world's leading manufacturer of steel structure</p>
                <p>
                  Providing professional services to customers who pursue perfection
                </p>
              </div>
              <a href="javascript:;" class="more scrolly" @click="forId('about')">Learn More</a>
            </section>
          </div>
        </div>
      </div>
      <keep-alive>
        <img
          src="@/components/videos/Home-1.gif"
          alt=""
          style="height: 100vh; width: 100vw"
        />
      </keep-alive>
    </div>
    <!-- 视频结束 -->
    <!-- 关于开始 -->
    <section id="about">
      <div class="row about-wrap">
        <div class="col-full">
          <div class="about-profile-bg">
            <div class="intro">
              <h3 class="animate-this">INTRODUCTION</h3>
              <p class="lead animate-this" style="text-align: left">
                <!-- <span>Huayin Group</span> -->
                We are an AISC/CWB certified company specialized in engineering
                design, fabrication and erection for steel construction
                business. Our highly automated plant in Nantong city is equipped
                with state-of-the-art machineries, including CNC laser cutting,
                plasma and Robot welding,allowing high degree of precision and
                production efficiency. This fabrication plant has a land area of
                125,000 sqm, with processing capacity of 50,000 ton/year of
                steel structure plus additional 30,000 tons/year for corrugated
                color plates for roofing / wall system. Since the inception in
                1994, we have been constructing industrial buildings for oversea
                investors in China. We have also been selected as quality steel
                structure supplier by famous EPC such as Fluor, MIH, Mori-Matsu,
                CC7, Worley, Thyssenkrupp, etc. for their international flagship
                projects worldwide. Starting from early 2000, our first-class
                structural steel has been exported to Canada, USA, Mexico,
                Germany, Hungary, Chile, Australia, Hungary and many African
                countries.
              </p>
            </div>
          </div>
        </div>
        <!-- end col-full  -->
      </div>
      <!-- end about-wrap  -->
    </section>
    <!-- 关于结束 -->
    <!-- 三大项开始 -->
    <div class="new-scheme-main">
      <p class="title">CORE SERVICE</p>
      <p class="titleTo">—— MORE ——</p>
      <div class="detail-list">
        <div class="detail">
          <img v-lazy="home1" alt="Lazy-loaded Image" />
          <div class="mask" @click="tohyzzen">
            <div class="text">
              <p class="symbol">FABRICATION</p>
              <p class="name">华胤制造</p>
            </div>
          </div>
        </div>
        <div class="detail">
          <img v-lazy="home2" alt="Lazy-loaded Image" />
          <div class="mask" @click="tohyjzen">
            <div class="text">
              <p class="symbol">CONSTRUCTION</p>
              <p class="name">华胤建造</p>
            </div>
          </div>
        </div>
        <div class="detail">
          <img v-lazy="home3" alt="Lazy-loaded Image" />
          <div class="mask" @click="tohyczen">
            <div class="text">
              <p class="symbol">ENGINEERING</p>
              <p class="name">华胤创造</p>
            </div>
          </div>
        </div>
        <div class="detail">
          <img v-lazy="home4" alt="Lazy-loaded Image" />
          <div class="mask" @click="tohyxnyen">
            <div class="text">
              <p class="symbol">NEW ENERGY</p>
              <p class="name">华胤新能源</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 三大项结束 -->
    <!-- 五大核心 -->
    <div class="new-scheme-main">
      <p class="title">CORE VALUES</p>
      <p class="titleToNo">—— MORE ——</p>
      <div>
        <ul class="ul">
          <li style="--accent-color:#41516C">
              <div class="date">Environmental Protection</div>
              <div class="title">
                <img v-lazy="home38" alt="Lazy-loaded Image" class="hxImg">
              </div>
              <div class="descr">Our company actively assumes environmental protection responsibilities by implementing measures such as energy conservation and emission reduction, optimizing resource management, and promoting circular utilization, aiming to alleviate the burden on the natural environment. We encourage employees to engage in environmental protection activities and collaborate hand in hand with the community to jointly contribute to safeguarding the earth's environment.  </div>
          </li>
          <li style="--accent-color:#FBCA3E">
              <div class="date">Social Responsibility</div>
              <div class="title">
                <img v-lazy="home39" alt="Lazy-loaded Image" class="hxImg">
              </div>
              <div class="descr">Social responsibility is what a good company should take the initiative to do, through responsible business practices, achieve environmental sustainability, respect human rights, promote community development, to enhance brand reputation and contribute to sustainable development.</div>
          </li>
          <li style="--accent-color:#E24A68">
              <div class="date">Cherish Employees</div>
              <div class="title">
                <img v-lazy="home40" alt="Lazy-loaded Image" class="hxImg">
              </div>
              <div class="descr">The company attracts and retains talent and drives long-term success by providing fair pay, career development, healthy and safe working conditions and work-life balance that unlock the potential of employees and enhance team cohesion.</div>
          </li>
          <li style="--accent-color:#1B5F8C">
              <div class="date">Emphasize Quality</div>
              <div class="title">
                <img v-lazy="home41" alt="Lazy-loaded Image" class="hxImg">
              </div>
              <div class="descr">Through strict quality control and continuous improvement, enterprises ensure that products and services exceed customer expectations, reduce waste, improve efficiency, and reduce costs to maintain market competitiveness and brand advantages.              </div>
          </li>
          <li style="--accent-color:#4CADAD">
              <div class="date">Sustainable Management</div>
              <div class="title">
                <img v-lazy="home42" alt="Lazy-loaded Image" class="hxImg">
              </div>
              <div class="descr">Sustainable management is the direction that Huayin has been pursuing, which requires enterprises to pay attention to environmental protection and social responsibility while pursuing economic benefits, to achieve environmental, economic and social sustainability, in order to ensure long-term development and be responsible for future generations.</div>
          </li>
        </ul>
      </div>
    </div>
    
    <!-- 项目开始 -->
    <div class="new-scheme-main">
      <p class="title" @click="tocgalen" style="cursor: pointer">
        TYPICAL CASE
      </p>
      <p @click="tocgalen" class="titleTo">—— MORE ——</p>
      <div class="detail-list"></div>
    </div>

    <!-- 走马灯 -->
    <div class="scrm">
      <!-- 使用swiper -->
      <div class="swiper-container">
        <swiper :options="swiperOption" class="swip">
          <swiper-slide
            v-for="(item, index) in homeImages"
            :key="index"
            class="swiper-slide"
            style="text-align: center; position: relative"
          >
            <div class="overlay">
              <transition name="fade">
                <div class="altitle">{{ item.title }}</div>
              </transition>
              <transition name="fade">
                <div class="text">{{ item.text }}</div>
              </transition>
              <transition name="fade" mode="out-in">
                <div class="details" @click="setCgalen(index + 1)">
                  {{ item.details }}
                </div>
              </transition>
            </div>
            <transition name="fade">
              <img :src="item.image" class="swiper-image" />
            </transition>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>
    <!-- 项目结束 -->
    <!-- 荣誉开始 -->
    <div class="new-scheme-main">
      <p class="title" @click="tohyryen" style="cursor: pointer">
        CERTIFICATION
      </p>
      <p @click="tohyryen" class="titleTo">—— MORE ——</p>
      <div class="detail-list"></div>
    </div>
    <div class="full-screen-portfolio" id="portfolio">
      <div class="container-fluid hidden-xs">
        <div class="col-md-3 col-sm-6">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home6"
                    :preview-src-list="[
                      home6,
                      home5,
                      home8,
                      home7,
                      home9,
                      home10,
                    ]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>China CQM</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home11"
                    :preview-src-list="[home11]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>America ASIC</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home12"
                    :preview-src-list="[home12, home13]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>America AWS</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home14"
                    :preview-src-list="[home14]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>Canada CWB</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home15"
                    :preview-src-list="[home15, home16, home17]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>Europe Applus</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home19"
                    :preview-src-list="[home19, home18]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>China SGS</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home20"
                    :preview-src-list="[home20]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>China SCS</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid visible-xs">
        <div class="col-md-3 col-sm-4 col-xs-4 ryfox">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home31"
                    :preview-src-list="[
                      home5,
                      home6,
                      home7,
                      home8,
                      home9,
                      home10,
                    ]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>CQM</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-4 col-xs-4 ryfox">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home32"
                    :preview-src-list="[home11]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>ASIC</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-4 col-xs-4 ryfox">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home33"
                    :preview-src-list="[home12, home13]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>AWS</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-4 col-xs-4 ryfox">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home34"
                    :preview-src-list="[home14]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>CWB</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-4 col-xs-4 ryfox">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home35"
                    :preview-src-list="[home15, home16, home17]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>Applus</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-4 col-xs-4 ryfox">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home36"
                    :preview-src-list="[home18, home19]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>SGS</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-4 col-xs-4 ryfox">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home37"
                    :preview-src-list="[home20]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>SCS</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 荣誉结束 -->
  </div>
</template>

<script>
import $ from 'jquery'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
var imagesLoaded = require('imagesloaded')
import { TweenMax } from 'gsap'
import { TimelineMax } from 'gsap'
import { gsap } from 'gsap'
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
import { TextPlugin } from 'gsap/TextPlugin'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
export default {
  data() {
    return {
      repla: false,
      home1: require('@/components/img/home/l4.jpg'),
      home2: require('@/components/img/home/l7.jpg'),
      home3: require('@/components/img/home/l1.jpg'),
      home4: require('@/components/img/home/l2.jpg'),
      home5: require('@/components/img/home/image11.png'),
      home6: require('@/components/img/home/image12.png'),
      home7: require('@/components/img/home/image13.png'),
      home8: require('@/components/img/home/image14.png'),
      home9: require('@/components/img/home/image15.png'),
      home10: require('@/components/img/home/image16.png'),
      home11: require('@/components/img/home/image17.png'),
      home12: require('@/components/img/home/image18.png'),
      home13: require('@/components/img/home/image19.png'),
      home14: require('@/components/img/home/image20.png'),
      home15: require('@/components/img/home/image21.png'),
      home16: require('@/components/img/home/image22.png'),
      home17: require('@/components/img/home/image23.png'),
      home18: require('@/components/img/home/image24.png'),
      home19: require('@/components/img/home/image25.png'),
      home20: require('@/components/img/home/image26.png'),
      home31: require('@/components/img/home/image42.png'),
      home32: require('@/components/img/home/image43.png'),
      home33: require('@/components/img/home/image44.png'),
      home34: require('@/components/img/home/image45.png'),
      home35: require('@/components/img/home/image46.png'),
      home36: require('@/components/img/home/image47.png'),
      home37: require('@/components/img/home/image48.png'),
      home38: require('@/components/img/home/hx1.jpg'),
      home39: require('@/components/img/home/hx2.jpg'),
      home40: require('@/components/img/home/hx3.jpg'),
      home41: require('@/components/img/home/hx4.jpg'),
      home42: require('@/components/img/home/hx5.jpg'),
      homeImages: [
      {
          image: require('@/components/img/cgal/al1.jpg'),
          title: 'Shanghai Huiqun Plaza',
          text: 'Shanghai Huiqun Plaza, a model of modern architecture in the city, blends innovation and practicality in its design and structural features, aiming to create a space that meets both modern aesthetics and functional needs......',
          details: 'Learn More',
        },
        {
          image: require('@/components/img/cgal/al2.jpg'),
          title: 'Xiamen Yinlu Group',
          text: 'Yinlu Group is the largest private food enterprise in Xiamen and is interested in the development of industrial tourism. Therefore, in the selection of structural materials, it is necessary to take into account the local climate characteristics of many typhoons and rains, and pay attention to the visual effect of the overall project and the surrounding environment......',
          details: 'Learn More',
        },
        {
          image: require('@/components/img/cgal/al3.jpg'),
          title: 'Summary of Honda projects',
          text: '4S car showroom is a general name for the four major functions of automobile sales, exhibition, maintenance and commercial office, and it is an important symbol of its birth and vigorous development of the automobile industry. Each brand has its own style in terms of independent design, but the main structure can be found in a regular way......',
          details: 'Learn More',
        },
        {
          image: require('@/components/img/cgal/al4.jpg'),
          title: 'Argyle International Airport',
          text: 'Argyle International Airport is built on about 275 acres of land with a paved runway measuring 2,743 meters (9,000 feet) long and 45 meters (150 feet) wide. The airport is designed to accommodate large jets like the Boeing 747-400......',
          details: 'Learn More',
        },
        {
          image: require('@/components/img/cgal/al5.jpg'),
          title: 'Bangladesh GF Project',
          text: 'GF Bangladesh is located in Norsindi District, Bangladesh. This project is of great significance, it is directly invested and constructed by the Bangladeshi government, and it is a landmark project to ensure the stable production and income of Bangladesh agriculture......',
          details: 'Learn More',
        },
        {
          image: require('@/components/img/cgal/al6.jpg'),
          title: 'Morimatsu VCR Canada Project',
          text: 'The Morimatsu VCR Canada project aims to use advanced water electrolysis to hydrogen production technology to convert non-recyclable waste and residual biomass into biofuels and circular chemicals to help achieve the Sustainable Development Goals......',
          details: 'Learn More',
        },
        // ...
      ],
      swiperOption: {
        notNextTick: false,
        loop: true,
        touchRatio: 2, // 触摸滑动的顺畅度
        initialSlide: 1, // 默认展示页
        autoplay: true, // 是否自动播放
        speed: 2000, // 播放速度
        slidesPerView: 'auto',
        centeredSlides: true,
        paginationClickable: true,
        spaceBetween: 5, // 模块之间的间隔
        on: {
          slideChangeTransitionEnd: function () {
            // 处理手动操作轮播图后后不再自动轮播
            this.autoplay.start()
          },
        },
        // 如果你需要导航按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          hideOnClick: false, //点击slide时显示/隐藏按钮。BUG处理：如果遇到无效，可增加样式 .swiper-container .swiper-button-hidden{ opacity : 0; }
          disabledClass: 'my-button-disabled', //前进后退按钮不可用时的类名。
          hiddenClass: 'my-button-hidden', //按钮隐藏时的Class
        },
      },
      showTitle: [],
      showDetails: [],
    }
  },
  components: {
    swiper,
    swiperSlide,
  },
  mounted() {
    this.repla = true
    $(document).ready(function ($) {
      'use strict'

      $(function () {
        // Vars
        var modBtn = $('#modBtn'),
          modal = $('#modal'),
          close = modal.find('.close-btn img'),
          modContent = modal.find('.modal-content')
        // })
        // 首页
        var $window = $(window);
        var $body =$('.hbody');

          // 添加 'is-loading' 类
          // $body.addClass('is-loading');

          // 当从缓存中恢复时移除 'is-loading' 类
          if (sessionStorage.getItem('pageWasCached')) {
            sessionStorage.removeItem('pageWasCached');
            window.setTimeout(function() {
              $body.removeClass('is-loading');
            }, 100);
          }

          // 页面加载时设置标志，以便在下次恢复时移除 'is-loading' 类
          sessionStorage.setItem('pageWasCached', true);

          // 监听 'load' 事件，处理页面首次加载的情况
          $(window).on('load', function() {
            window.setTimeout(function() {
              $body.removeClass('is-loading');
            }, 100);
          });



        $window.on('scroll', function () {
          // 获取可视窗口的顶部和底部位置
          var windowHeight = $(window).height()
          var scrollTop = $(window).scrollTop()
          var scrollBottom = scrollTop + windowHeight

          // 循环检查每个内容元素是否在可视窗口内
          $('#about .about-wrap').each(function () {
            var elementTop = $(this).offset().top
            var elementBottom = elementTop + $(this).outerHeight()
            // 如果内容元素出现在可视窗口内，应用酷炫的 CSS3 动画
            if (elementTop < scrollBottom && elementBottom > scrollTop) {
              $(this).css({
                animation: 'fadeInFromLeft 1s ease both',
              })
            }
          })
          $('#services .services-content').each(function () {
            var elementTop = $(this).offset().top
            var elementBottom = elementTop + $(this).outerHeight()
            // 如果内容元素出现在可视窗口内，应用酷炫的 CSS3 动画
            if (elementTop < scrollBottom && elementBottom > scrollTop) {
              $(this).addClass('animate__animated animate__zoomIn')
            }
          })
          $('#services .col-full').each(function () {
            var elementTop = $(this).offset().top
            var elementBottom = elementTop + $(this).outerHeight()
            // 如果内容元素出现在可视窗口内，应用酷炫的 CSS3 动画
            if (elementTop < scrollBottom && elementBottom > scrollTop) {
              $(this).addClass('animate__animated animate__slideInDown')
            }
          })
          $('.new-scheme-main .detail').each(function () {
            var elementTop = $(this).offset().top
            var elementBottom = elementTop + $(this).outerHeight()
            // 如果内容元素出现在可视窗口内，应用酷炫的 CSS3 动画
            if (elementTop < scrollBottom && elementBottom > scrollTop) {
              $(this).addClass('animate__animated animate__fadeIn')
            }
          })
          $('.slideshow').each(function () {
            var elementTop = $(this).offset().top
            var elementBottom = elementTop + $(this).outerHeight()
            // 如果内容元素出现在可视窗口内，应用酷炫的 CSS3 动画
            if (elementTop < scrollBottom && elementBottom > scrollTop) {
              $(this).addClass('animate__animated animate__fadeInLeft')
            }
          })
          $('#portfolio .portfolio-item').each(function () {
            var elementTop = $(this).offset().top
            var elementBottom = elementTop + $(this).outerHeight()
            // 如果内容元素出现在可视窗口内，应用酷炫的 CSS3 动画
            if (elementTop < scrollBottom && elementBottom > scrollTop) {
              $(this).addClass('animate__animated animate__fadeIn')
            }
          })
        })

        // 初始化时触发一次滚动事件，以显示可视区域内的内容
        $(window).trigger('scroll')
        // open modal when click on open modal button
        modBtn.on('click', function () {
          modal.css('display', 'block')
          modContent
            .removeClass('modal-animated-out')
            .addClass('modal-animated-in')
        })

        // close modal when click on close button or somewhere out the modal content
        $(document).on('click', function (e) {
          var target = $(e.target)
          if (target.is(modal) || target.is(close)) {
            modContent
              .removeClass('modal-animated-in')
              .addClass('modal-animated-out')
              .delay(300)
              .queue(function (next) {
                modal.css('display', 'none')
                next()
              })
          }
        })
      })

      // on click event on all anchors with a class of scrollTo
      $('a.scrollTo').on('click', function () {
        // data-scrollTo = section scrolling to name
        var scrollTo = $(this).attr('data-scrollTo')

        // toggle active class on and off. added 1/24/17
        $('a.scrollTo').each(function () {
          if (scrollTo == $(this).attr('data-scrollTo')) {
            $(this).addClass('active')
          } else {
            $(this).removeClass('active')
          }
        })

        // animate and scroll to the sectin
        $('.hbody, html').animate(
          {
            // the magic - scroll to section
            scrollTop: $('#' + scrollTo).offset().top,
          },
          1000
        )
        return false
      })
    })
    gsap.registerPlugin(MotionPathPlugin, TextPlugin, ScrollToPlugin)
    // provide jQuery argument
    imagesLoaded.makeJQueryPlugin($)
    $('.slideshow')
      .imagesLoaded({ background: true })
      .done(function () {
        // hide loader
        $('.loader').addClass('is-loaded')

        // init variables
        var slideshow = $('.slideshow'),
          navigation = $('.navigation'),
          navigationItem = $('.navigation-item'),
          detailItem = $('.detail-item'),
          rotation,
          type = '_short'

        // prepare letters
        $('.headline').each(function () {
          // eslint-disable-next-line no-control-regex
          $(this).html(
            $(this)
              .text()
              // eslint-disable-next-line no-control-regex
              .replace(/([^\x00-\x80]|\w)/g, "<span class='letter'>$&</span>")
          )
        })

        // prepare navigation and set navigation items on the right place
        navigationItem.each(function (index, elem) {
          TweenMax.set(elem, {
            left: navigation.width() / 2 - navigationItem.width() / 2 - 10,
            rotation: 90 + (index * 360) / navigationItem.length,
            transformOrigin: '50% ' + navigation.width() / 2 + 'px',
          })
          TweenMax.set($(elem).find('.rotate-holder'), {
            text: String((index * 360) / navigationItem.length),
          })
          TweenMax.set($(elem).find('.background-holder'), {
            rotation: -90 - (index * 360) / navigationItem.length,
          })
        })

        // set tween values
        function setTweenValues() {
          rotation = Number($(this).find('.rotate-holder').text())
        }

        // do tween
        function doTween(target) {
          var timeline = new TimelineMax()

          // add/remove class "active" from navigation & detail
          navigationItem.each(function () {
            $(this).removeClass('active')
            if ($(this).index() == $(target).index()) {
              $(this).addClass('active')
            }
          })
          detailItem.each(function () {
            $(this).removeClass('active')
            if ($(this).index() == $(target).index()) {
              $(this).addClass('active')
            }
          })

          timeline
            .to(navigation, 0.6, {
              rotation: -rotation + type,
              transformOrigin: '50% 50%',
            })
            .staggerTo(
              navigationItem.find('.background-holder'),
              0.6,
              {
                //function that returns a value
                rotation: function (index, element) {
                  return (
                    -90 -
                    Number($(element).prev('.rotate-holder').text()) +
                    rotation +
                    type
                  )
                },
                transformOrigin: '50% 50%',
              },
              0,
              '-=0.6'
            )
            .staggerFromTo(
              $('.active').find('.letter'),
              0.3,
              {
                autoAlpha: 0,
                x: -100,
              },
              {
                autoAlpha: 1,
                x: 0,
              },
              0.025,
              '-=0.3'
            )
            .fromTo(
              $('.active').find('.background'),
              0.9,
              {
                autoAlpha: 0,
                x: -100,
              },
              {
                autoAlpha: 1,
                x: 0,
              },
              0.05,
              '+=0.3'
            )
        }

        // click/hover on items
        navigationItem.on('mouseenter', setTweenValues)
        navigationItem.on('click', function () {
          doTween($(this))
        })

        // on load show slideshow as well as first "active" navigation/detail item
        TweenMax.to(slideshow, 1, { autoAlpha: 1 })
        TweenMax.to($('.active').find('.letter'), 0.7, { autoAlpha: 1, x: 0 })
        TweenMax.to($('.active').find('.background'), 0.7, {
          autoAlpha: 1,
          x: 0,
        })
      })

    // fast fix for resize window and refresh view, attention: not use in production, only for demo purposes!
    ;(function () {
      var width = window.innerWidth

      window.addEventListener('resize', function () {
        if (window.innerWidth !== width) {
          window.location.reload(true)
        }
      })
    })()
  },
  methods: {
    // 调用全局方法，滚动指定id
    forId(tId) {
      console.log(tId);
      this.$store.dispatch('toID', tId);
    },

    startAnimation() {
      this.homeImages.forEach((_, index) => {
        setTimeout(() => {
          this.showTitle[index] = true
        }, index * 1000) // 每隔1秒显示下一张图片的标题

        setTimeout(() => {
          this.showDetails[index] = true
        }, (index + 1) * 1000) // 每隔1秒显示下一张图片的详情
      })
    },
    tohyzzen() {
      this.$router.push('/hyzzen')
      location.reload()
    },
    tohyjzen() {
      this.$router.push('/hyjzen')
      location.reload()
    },
    tohyczen() {
      this.$router.push('/hyczen')
      location.reload()
    },
    tohyxnyen() {
      this.$router.push('/hyxnyen')
      location.reload()
    },
    tocgalen() {
      this.$router.push('/cgalen')
      location.reload()
    },
    tohyryen() {
      this.$router.push({
        path: '/gyhyen',
        hash: '#gsry',
      })
      location.reload()
    },
    setCgalen(index) {
      this.$router.push({ path: '/cgalen', query: { num: index } })
    },
  },
}
</script>

<style scoped>
@import url('../Home/css/demo.css');
@import url('../Home/css/fontAwesome.css');
@import url('../Home/css/light-box.css');
@import url('../Home/css/templatemo-style.css');
.titleTo {
  font-size: 15px;
  color: #ccc;
  text-align: center;
  margin: 20px 0 -30px 0;
  cursor: pointer;
}
@media screen and (max-width: 736px) {
  .full-screen-portfolio .portfolio-item h1 {
    font-size: 14px;
  }
}
.scrm {
  padding: 0 20px;
}
.swiper-container {
  width: 100%;
  height: 70vh;
  position: relative;
}

.swiper-slide {
  text-align: center;
  position: relative;
}

.overlay {
  position: absolute;
  top: 10%;
  left: 10%;
  width: 20vw;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 20px;
  border-radius: 10px;
  color: white;
}

.altitle {
  font-size: 30px;
  font-family: 微软雅黑;
  margin-bottom: 10px;
}
.text {
  font-size: 16px;
  font-family: 微软雅黑;
  margin: 10px 0;
}
.details {
  font-size: 20px;
  font-family: 微软雅黑;
  background-color: rgba(255, 255, 255, 0.3);
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  z-index: 999;
}

.swiper-image {
  width: 90vw;
  height: 70vh;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.swip {
  height: 70vh;
}
.ryfox {
  padding: 0 3px;
}
@media screen and (max-width: 736px) {
  #banner h2 {
    font-size: 2.2em;
  }
  #video-container .video-content .inner p {
    font-size: 15px;
  }
  .full-screen-portfolio .portfolio-item h1 {
    font-size: 16px;
    margin-top: 8px;
    margin-bottom: 6px;
  }
  .swiper-container {
    width: 100%;
    height: 300px;
    position: relative;
  }
  .swip {
    height: 300px;
  }
  .swiper-image {
    width: 100vw;
    height: 300px;
  }
  .overlay {
    position: absolute;
    top: auto;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    padding: 5px;
    border-radius: 10px;
    color: white;
  }
  .altitle {
    font-size: 15px;
    font-family: 微软雅黑;
    margin-bottom: 10px;
  }
  .text {
    font-size: 10px;
    font-family: 微软雅黑;
    margin: 10px 0;
  }
  .details {
    font-size: 12px;
    font-family: 微软雅黑;
    background-color: rgba(255, 255, 255, 0.3);
    padding: 5px;
    border-radius: 5px;
    cursor: pointer;
  }
  .scrm {
    padding: 0 5px;
  }
}
/* 五大核心 */
/* *,
*::before,
*::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
} */
:root{
    --color: rgba(30, 30, 30);
    --bgColor: rgba(245, 245, 245);
}
 
.container {
     
    min-height: 100vh;
    display: grid;
    align-content: center;
    gap: 2rem;
    padding: 2rem;
    font-family: "Poppins", sans-serif;
    color: var(--color);
    background: var(--bgColor);
}
 
h1 {
    text-align: center;
}
 
.ul {
    --col-gap: 2rem;
    --row-gap: 2rem;
    --line-w: 0.25rem;
    display: grid;
    grid-template-columns: var(--line-w) 1fr;
    grid-auto-columns: max-content;
    column-gap: var(--col-gap);
    list-style: none;
    width: 90vw;
    margin-inline: auto;
}

.hxImg{
  padding: 5px;
  height: 20vh;
  width: 100%;
}
 
/* line */
.ul::before {
    content: "";
    grid-column: 1;
    grid-row: 1 / span 20;
    background: rgb(225, 225, 225);
    border-radius: calc(var(--line-w) / 2);
}
 
/* columns*/
 
/* row gaps */
.ul li:not(:last-child) {
    margin-bottom: var(--row-gap);
}
 
/* card */
.ul li {
    grid-column: 2;
    --inlineP: 1.5rem;
    margin-inline: var(--inlineP);
    grid-row: span 2;
    display: grid;
    grid-template-rows: min-content min-content min-content;
}
 
/* date */
.ul li .date {
    --dateH: 5rem;
    height: var(--dateH);
    margin-inline: calc(var(--inlineP) * -1);
 
    text-align: center;
    background-color: var(--accent-color);
 
    color: white;
    font-size: 2.25rem;
    font-weight: 700;
 
    display: grid;
    place-content: center;
    position: relative;
 
    border-radius: calc(var(--dateH) / 2) 0 0 calc(var(--dateH) / 2);
}
 
/* date flap */
.ul li .date::before {
    content: "";
    width: var(--inlineP);
    aspect-ratio: 1;
    background: var(--accent-color);
    background-image: linear-gradient(rgba(0, 0, 0, 0.2) 100%, transparent);
    position: absolute;
    top: 100%;
 
    clip-path: polygon(0 0, 100% 0, 0 100%);
    right: 0;
}
 
/* circle */
.ul li .date::after {
    content: "";
    position: absolute;
    width: 2rem;
    aspect-ratio: 1;
    background: var(--bgColor);
    border: 0.3rem solid var(--accent-color);
    border-radius: 50%;
    top: 50%;
 
    transform: translate(50%, -50%);
    right: calc(100% + var(--col-gap) + var(--line-w) / 2);
}
 
/* title descr */
.ul li .title,
.ul li .descr {
    background: var(--bgColor);
    position: relative;
    padding-inline: 1.5rem;
}
 
.ul li .title {
    overflow: hidden;
    padding-block-start: 1.5rem;
    padding-block-end: 1rem;
    font-weight: 500;
}
 
.ul li .descr {
    color: #000;
    padding-block-end: 1.5rem;
    font-weight: 300;
    font-size: 14px;
    font-family: "等线 Light";
}
 
/* shadows */
.ul li .title::before,
.ul li .descr::before {
    content: "";
    position: absolute;
    width: 90%;
    height: 0.5rem;
    background: rgba(0, 0, 0, 0.5);
    left: 50%;
    border-radius: 50%;
    filter: blur(4px);
    transform: translate(-50%, 50%);
}
 
.ul li .title::before {
    bottom: calc(100% + 0.125rem);
}
 
.ul li .descr::before {
    z-index: -1;
    bottom: 0.25rem;
}
 
@media (min-width: 40rem) {
    .ul {
        grid-template-columns: 1fr var(--line-w) 1fr;
    }
 
    .ul::before {
        grid-column: 2;
    }
 
    .ul li:nth-child(odd) {
        grid-column: 1;
    }
 
    .ul li:nth-child(even) {
        grid-column: 3;
    }
 
    /* start second card */
    .ul li:nth-child(2) {
        grid-row: 2/4;
    }
 
    .ul li:nth-child(odd) .date::before {
        clip-path: polygon(0 0, 100% 0, 100% 100%);
        left: 0;
    }
 
    .ul li:nth-child(odd) .date::after {
        transform: translate(-50%, -50%);
        left: calc(100% + var(--col-gap) + var(--line-w) / 2);
    }
 
    .ul li:nth-child(odd) .date {
        border-radius: 0 calc(var(--dateH) / 2) calc(var(--dateH) / 2) 0;
    }

    .hxImg{
      padding: 10px 20px;
      height: 35vh;
      width: 100%;
    }
    .ul li .descr{
      font-size: 18px;
    }
}
.titleToNo{
  font-size: 15px;
  color: #ccc;
  text-align: center;
  margin: 20px 0;
  cursor: pointer;
}
</style>
